/* lkp2-9.js - Lush Keepsake personaliser v2, part 9 of 16 (readable source: build/src/lkp2.js; split by build/minify.py) */
(function(){'use strict';var K=window.__lkp2k=window.__lkp2k||{};
var D=K.D,DASH=K.DASH,EN=K.EN,SEP_RE=K.SEP_RE,POUND_FMT=K.POUND_FMT,EMAIL=K.EMAIL,BLANK_DEFAULT=K.BLANK_DEFAULT,NUM_WORDS=K.NUM_WORDS,SWATCH=K.SWATCH,INK_DARK=K.INK_DARK,INK_LIGHT=K.INK_LIGHT,CAP=K.CAP,esc=K.esc,h=K.h,clamp=K.clamp,clone=K.clone,lc=K.lc,isObj=K.isObj,merge=K.merge,firstInt=K.firstInt,money=K.money,hash=K.hash,debounce=K.debounce,cleanLabel=K.cleanLabel,fontByN=K.fontByN,swatchFor=K.swatchFor,inkFor=K.inkFor,CFG=K.CFG,loadConfig=K.loadConfig,IMG=K.IMG,loadImg=K.loadImg,ART_INK=K.ART_INK,ARTTXT=K.ARTTXT,artBaseUrl=K.artBaseUrl,artText=K.artText,artRaster=K.artRaster,MOTIF=K.MOTIF,motifImg=K.motifImg,MAPS=K.MAPS,mapNorm=K.mapNorm,mapDist=K.mapDist,mapJson=K.mapJson,mapFind=K.mapFind,mapPlace=K.mapPlace,ICONIMG=K.ICONIMG,iconSvg=K.iconSvg,iconImg=K.iconImg,FONTREADY=K.FONTREADY,fontReady=K.fontReady,QR=K.QR,loadQR=K.loadQR,cleanRegion=K.cleanRegion,LEGACY=K.LEGACY,fallbackConfig=K.fallbackConfig,lineFields=K.lineFields,P=K.P,MORSE=K.MORSE,pathPts=K.pathPts,polyLen=K.polyLen,visRun=K.visRun,drawPathText=K.drawPathText,toMorse=K.toMorse,subMax=K.subMax,subKey=K.subKey,propKey=K.propKey,faceKey=K.faceKey,textKey=K.textKey,optText=K.optText,propVal=K.propVal,fmtDate=K.fmtDate,fmtTime=K.fmtTime,drawPlaceholder=K.drawPlaceholder,drawClock=K.drawClock,drawCalendar=K.drawCalendar,drawSpotify=K.drawSpotify,drawQR=K.drawQR,NOISE=K.NOISE,noisePattern=K.noisePattern,autoTone=K.autoTone,shade=K.shade,drawPlate=K.drawPlate,residual=K.residual,METAL=K.METAL;
P.prototype.viewRect = function (ph, W, H, A, mode) {
var z = this.zonePx(ph, W, H), sw, sh, cx = z.cx, cy = z.cy;
if (mode === 'full') { if (W / H > A) { sw = W; sh = W / A; } else { sh = H; sw = H * A; } return { x: W / 2 - sw / 2, y: H / 2 - sh / 2, w: sw, h: sh }; }
if (ph.isArt && mode !== 'close') {
var fitW = W / H > A ? W : H * A, zr = ph.view ? (ph.view.zoom || 1) : 1, zw0 = ph.zone.w / 100 * W / fitW;
var zm = clamp(0.36 / Math.max(zw0, 0.01), 1, Math.max(1, zr));
var bw0 = Math.abs(z.w * Math.cos(z.rot)) + Math.abs(z.h * Math.sin(z.rot)), bh0 = Math.abs(z.w * Math.sin(z.rot)) + Math.abs(z.h * Math.cos(z.rot));
var ux0 = z.cx - bw0 / 2, ux1 = z.cx + bw0 / 2, uy0 = z.cy - bh0 / 2, uy1 = z.cy + bh0 / 2;
(ph.motifOn || []).forEach(function (m) { var b = m.box; ux0 = Math.min(ux0, (b.x - b.w / 2) / 100 * W); ux1 = Math.max(ux1, (b.x + b.w / 2) / 100 * W); uy0 = Math.min(uy0, (b.y - b.h / 2) / 100 * H); uy1 = Math.max(uy1, (b.y + b.h / 2) / 100 * H); });
var uw = Math.max(ux1 - ux0, 1), uh = Math.max(uy1 - uy0, 1), Hs = fitW / A;
var ew = Math.min(fitW, Hs * 1.5); // a wide stage (the modal) must not zoom the piece past its height
var zMin = Math.min(Math.max(0.6 * ew / uw, 0.22 * Hs / uh), 0.97 * fitW / uw, 0.9 * Hs / uh, 6), byMin = zMin > zm;
if (byMin) zm = zMin;
sw = fitW / zm; sh = sw / A;
var vx = ph.view && ph.view.x != null && !byMin ? ph.view.x : (byMin ? (ux0 + ux1) / 2 / W * 100 : ph.zone.x), vy = ph.view && ph.view.y != null && !byMin ? ph.view.y : (byMin ? (uy0 + uy1) / 2 / H * 100 : ph.zone.y);
cx = zm <= 1 ? W / 2 : vx / 100 * W; cy = zm <= 1 ? H / 2 : vy / 100 * H;
return { x: clamp(cx - sw / 2, Math.min(0, W - sw), Math.max(0, W - sw)), y: clamp(cy - sh / 2, Math.min(0, H - sh), Math.max(0, H - sh)), w: sw, h: sh };
}
if (ph.view && mode !== 'close') { sw = W / (ph.view.zoom || 1); sh = sw / A; cx = (ph.view.x != null ? ph.view.x : ph.zone.x) / 100 * W; cy = (ph.view.y != null ? ph.view.y : ph.zone.y) / 100 * H; }
else {
var bw = Math.abs(z.w * Math.cos(z.rot)) + Math.abs(z.h * Math.sin(z.rot)), bh = Math.abs(z.w * Math.sin(z.rot)) + Math.abs(z.h * Math.cos(z.rot));
var fill = mode === 'close' ? 0.92 : 0.66;
sw = Math.max(bw / fill, bh / fill * A); sh = sw / A;
var minW = Math.min(W, H * A) / 5; if (sw < minW) { sw = minW; sh = sw / A; }
}
var fit = Math.min(1, W / sw, H / sh); if (mode !== 'close' && fit < 1) { sw *= fit; sh *= fit; }
var x = clamp(cx - sw / 2, Math.min(0, W - sw), Math.max(0, W - sw)), y = clamp(cy - sh / 2, Math.min(0, H - sh), Math.max(0, H - sh));
return { x: x, y: y, w: sw, h: sh };
};
P.prototype.render = function (cv, f, mode, opts) {
var me = this, colour = this.colour(), ph = this.photo(f, colour), draw = this.drawable(f);
opts = opts || {};
if (mode === 'full' && !opts.single && ph.isArt && (draw || (ph.motifOn || []).length)) {
var stem = function (g) { return /\d$/.test(g.id) ? g.id.replace(/\d+$/, '') : null; };
var sib = this.faces().filter(function (g) {
if (stem(g) === null || stem(g) !== stem(f)) return false;
var pg = me.photo(g, colour); if (!me.drawable(g) && !(pg.motifOn || []).length) return false;
return pg.isArt && pg.art === ph.art && Math.abs(pg.zone.x - ph.zone.x) < 2 && Math.abs(pg.zone.y - ph.zone.y) < 2;
});
if (sib.length > 1) return this.renderRow(cv, f, sib, opts);
}
if (ph.dirty && draw && !ph.isArt) { if (mode === 'full') draw = false; else { var pp = this.platePh(f, colour); pp.fromDirty = true; pp.count = ph.count; pp.idx = ph.idx; ph = pp; } }
if (!draw && !ph.hasZone && !ph.view && !(ph.isArt && ph.whole)) mode = 'full';
if (ph.isArt && ph.whole && mode === 'face') mode = 'full'; // a choice face (cord, chain) shows the whole item, not the engraving zone
var bp;
if (ph.isArt) {
var zf = mode === 'full' || !ph.view ? 1 : (ph.view.zoom || 1) * (mode === 'close' ? 1.8 : 1);
ph.R = clamp(Math.ceil(cv.width * zf / 800) * 800, 1600, window.innerWidth < 750 ? 2400 : 3200);
bp = this.base(ph)['catch'](function () { ph = me.platePh(f, colour); return me.base(ph); });
} else bp = this.base(ph);
return bp.then(function (base) {
var W = base.width, H = base.height, cw = cv.width, ch = cv.height, A = cw / ch;
var fcss = []; var fontN = fontByN(me.fontOf(f)); fcss.push(fontN.css);
Object.keys(D.STYLE_FONTS || {}).forEach(function (k) { fcss.push(D.STYLE_FONTS[k]); });
var waits = fcss.map(fontReady).filter(function (x) { return x !== true; });
if (waits.length) return Promise.all(waits).then(function () { return me.render(cv, f, mode, opts); });
var mctx = me.mctx || (me.mctx = document.createElement('canvas').getContext('2d'));
var plan = draw ? me.plan(f, ph, W, H, mctx, opts) : { ops: [], err: null, ghost: false, z: me.zonePx(ph, W, H) };
if (plan.ghost && (me.cfg.example === false || f.example === false)) { plan.ops = []; plan.noExample = true; }
var motifs = ph.isArt ? (ph.motifOn || []) : [];
if ((!draw || !plan.ops.length) && ph.isArt && ph.hasZone && f.artNote && !f.artNoteBox && !motifs.length) {
var zn = me.zonePx(ph, W, H), nt = me.noteText(f, f.artNote);
plan = { ops: [{ k: 'ph', x: 0, y: 0, w: zn.w * (zn.ellipse ? 0.72 : 0.92), h: zn.h * (zn.ellipse ? 0.6 : 0.86), txt: nt, noIcon: true }], err: plan.err, ghost: true, noExample: true, z: zn };
draw = true;
}
if (!draw && ph.dirty && me.drawable(f)) { var pp2 = me.platePh(f, colour); plan.err = me.plan(f, pp2, 1200, 900, mctx, opts).err; }
if (!draw && motifs.length) draw = true;
var vr = me.viewRect(ph, W, H, A, mode), k = cw / vr.w;
var ctx = cv.getContext('2d');
ctx.setTransform(1, 0, 0, 1, 0, 0);
ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, cw, ch);
ctx.imageSmoothingQuality = 'high';
ctx.drawImage(base, vr.x, vr.y, vr.w, vr.h, 0, 0, cw, ch);
plan.photo = ph; plan.raw = !draw;
if (ph.isArt && ph.solid) me.drawSolid(ctx, f, ph, W, H, k, vr);
if (ph.isArt && ph.hasZone && f.artNote && f.artNoteBox && !motifs.length) {
var nb = f.artNoteBox;
ctx.save(); ctx.globalAlpha = 0.45; ctx.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k);
drawPlaceholder(ctx, { x: nb.x / 100 * W, y: nb.y / 100 * H, w: nb.w / 100 * W, h: nb.h / 100 * H, txt: me.noteText(f, f.artNote), noIcon: true });
ctx.restore();
}
if (!draw && ph.isArt && ph.whole && !opts.solo) {
var eng = me.faces().filter(function (g) { return g.id !== f.id && me.drawable(g) && (me.hasContent(g) || !(me.cfg.example === false || g.example === false)); });
if (eng.length) { plan = { ops: [], err: plan.err, ghost: !eng.some(function (g) { return me.hasContent(g); }), z: me.zonePx(ph, W, H) }; draw = true; }
}
if (!draw) return plan;
var L = me._layer || (me._layer = document.createElement('canvas'));
L.width = cw; L.height = ch;
var l = L.getContext('2d'), z = plan.z, pend = [];
var paint = function (pl) {
var zz = pl.z;
l.save(); l.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k);
l.translate(zz.cx, zz.cy); l.rotate(zz.rot); if (zz.skew) l.transform(1, 0, Math.tan(zz.skew), 1, 0, 0);
if (zz.ellipse) { l.beginPath(); l.ellipse(0, 0, zz.w / 2, zz.h / 2, 0, 0, Math.PI * 2); l.clip(); }
pend = pend.concat(me.drawOps(l, pl, k));
l.restore();
};
motifs.forEach(function (m) {
if (m.outline) { me.drawOutline(l, m, W, H, k, vr, pend, plan.ghost); return; }
var mp = motifImg(me.artBase, m.id);
if (!mp.done) { pend.push(mp.then(function () {}, function () {})); return; }
var im = mp.done, bw = m.box.w / 100 * W, bh = m.box.h / 100 * H, r = Math.min(bw / im.width, bh / im.height);
l.save(); l.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k);
if (m.ex && !plan.ghost) l.globalAlpha = 0.35;
l.drawImage(im, m.box.x / 100 * W - im.width * r / 2, m.box.y / 100 * H - im.height * r / 2, im.width * r, im.height * r);
l.restore();
});
paint(plan);
var spots = ph.whole ? [] : [ph.zone];
if (ph.isArt && !opts.solo) me.faces().forEach(function (g) {
if (g.id === f.id || !me.drawable(g)) return;
if (!me.hasContent(g) && (!plan.ghost || plan.noExample || me.cfg.example === false || g.example === false)) return;
var pg = me.photo(g, colour); if (!pg.isArt || pg.art !== ph.art || pg.fin !== ph.fin) return;
if (spots.some(function (q) { return Math.abs(pg.zone.x - q.x) < 2 && Math.abs(pg.zone.y - q.y) < 2; })) return; // same spot (front/back on one render): only one face
var plg = me.plan(g, pg, W, H, mctx, {}); if (!plg.ghost || plan.ghost) { paint(plg); spots.push(pg.zone); }
});
l.setTransform(1, 0, 0, 1, 0, 0);
var tone, ink, light;
if (ph.isArt) { light = ph.tone === 'light'; ink = ph.ink || (light ? INK_LIGHT : INK_DARK._); tone = light ? ink : 'dark'; }
else {
tone = ph.ink && ph.ink !== 'auto' ? ph.ink : autoTone(base, z);
ink = inkFor(tone, colour);
light = tone === 'light' || (tone.charAt(0) === '#' && parseInt(tone.slice(1, 3), 16) > 160);
}
var printed = me.cfg.process === 'printed';
if (!printed) { l.globalCompositeOperation = 'destination-out'; l.globalAlpha = ph.soft ? 0.5 : 0.45; l.fillStyle = noisePattern(l); l.fillRect(0, 0, cw, ch); l.globalAlpha = 1; }
var dpr = opts.dpr || Math.max(1, cv.width / (cv.clientWidth || cv.width));
var alpha = plan.ghost ? (ph.isArt ? 0.95 : ((ph.soft || (!light && autoTone(base, z) === 'light')) ? 0.62 : 0.32)) : 1;
if (printed && ph.isArt) {
l.globalCompositeOperation = 'source-in'; l.fillStyle = ink; l.fillRect(0, 0, cw, ch);
ctx.save(); ctx.globalAlpha = alpha; ctx.drawImage(L, 0, 0); ctx.restore();
} else if (!light) {
var Hc = me._hl || (me._hl = document.createElement('canvas')); Hc.width = cw; Hc.height = ch;
var hx = Hc.getContext('2d'); hx.drawImage(L, 0, 0); hx.globalCompositeOperation = 'source-in'; hx.fillStyle = '#fff'; hx.fillRect(0, 0, cw, ch);
ctx.save(); ctx.globalAlpha = 0.22 * alpha; ctx.globalCompositeOperation = 'screen'; ctx.drawImage(Hc, 0.6 * dpr, 0.8 * dpr); ctx.restore();
l.globalCompositeOperation = 'source-in'; l.fillStyle = ink; l.fillRect(0, 0, cw, ch);
ctx.save(); ctx.globalAlpha = alpha; ctx.globalCompositeOperation = 'multiply';
try { ctx.filter = 'blur(' + (0.25 * dpr) + 'px)'; } catch (e) {}
ctx.drawImage(L, 0, 0); ctx.restore();
} else {
if (ph.soft) {
var Dc = me._hl || (me._hl = document.createElement('canvas')); Dc.width = cw; Dc.height = ch;
var dx = Dc.getContext('2d'); dx.drawImage(L, 0, 0); dx.globalCompositeOperation = 'source-in'; dx.fillStyle = '#000'; dx.fillRect(0, 0, cw, ch);
ctx.save(); ctx.globalAlpha = 0.55 * alpha; ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(Dc, -0.7 * dpr, -0.9 * dpr); ctx.restore();
}
l.globalCompositeOperation = 'source-in'; l.fillStyle = tone.charAt(0) === '#' ? tone : INK_LIGHT; l.fillRect(0, 0, cw, ch);
ctx.save(); ctx.globalAlpha = alpha; ctx.globalCompositeOperation = 'screen';
try { ctx.filter = 'blur(' + (0.3 * dpr) + 'px)'; } catch (e) {}
ctx.drawImage(L, 0, 0); ctx.restore();
}
if (opts.hl && ph.hasZone && z && !(ph.dirty && !ph.fromDirty)) {
var pad = 7 * dpr / k;
ctx.save(); ctx.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k); ctx.translate(z.cx, z.cy); ctx.rotate(z.rot || 0);
ctx.strokeStyle = 'rgba(156,127,78,.95)'; ctx.lineWidth = 1.6 * dpr / k; ctx.setLineDash([5 * dpr / k, 4 * dpr / k]);
ctx.beginPath();
if (z.ellipse) ctx.ellipse(0, 0, z.w / 2 + pad, z.h / 2 + pad, 0, 0, Math.PI * 2);
else if (ctx.roundRect) ctx.roundRect(-z.w / 2 - pad, -z.h / 2 - pad, z.w + 2 * pad, z.h + 2 * pad, 4 * dpr / k);
else ctx.rect(-z.w / 2 - pad, -z.h / 2 - pad, z.w + 2 * pad, z.h + 2 * pad);
ctx.stroke(); ctx.restore();
}
if (me.debug) {
ctx.save(); ctx.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k); ctx.translate(z.cx, z.cy); ctx.rotate(z.rot);
ctx.strokeStyle = '#ff0055'; ctx.lineWidth = 1.5 / k; ctx.setLineDash([4 / k, 3 / k]);
if (z.ellipse) { ctx.beginPath(); ctx.ellipse(0, 0, z.w / 2, z.h / 2, 0, 0, Math.PI * 2); ctx.stroke(); } else ctx.strokeRect(-z.w / 2, -z.h / 2, z.w, z.h);
ctx.restore();
(ph.keepOut || []).forEach(function (q) {
ctx.save(); ctx.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k); ctx.strokeStyle = '#00a0ff'; ctx.lineWidth = 1.5 / k; ctx.beginPath();
if (q.shape === 'circle') ctx.arc(q.x / 100 * W, q.y / 100 * H, q.r / 100 * W, 0, Math.PI * 2); else ctx.rect((q.x - q.w / 2) / 100 * W, (q.y - q.h / 2) / 100 * H, q.w / 100 * W, q.h / 100 * H);
ctx.stroke(); ctx.restore();
});
}
if (pend.length) Promise.all(pend).then(function () { if (opts.again !== false) me.render(cv, f, mode, { again: false, ghost: opts.ghost, dpr: opts.dpr, hl: opts.hl }).then(function () { if (opts.after) opts.after(); }); });
plan.photo = ph;
return plan;
}).catch(function (e) {
if (window.console) console.warn('[lkp2] render failed', e);
return { err: null, ops: [] };
});
};
})();